<template>
  <div>
    <section class="bg-white py-8 border-b-2 border-gray-300">
      <div class="w-full md:w-10/12 mx-auto flex flex-wrap px-4 md:px-0">
        <div class="flex w-full md:w-2/3 lg:w-1/2 flex-col justify-center items-start">
          <h2 class="font-bold text-2xl">Login</h2>
          <h3 class="text-xl text-gray-600 mr-5 mt-5">You will now be directed to the login page.</h3>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$authService.login();
  }
};
</script>